module.exports = __webpack_public_path__ + "static/media/c5bannerModulE_small.167262a4.jpg";